import { motion } from 'framer-motion';
import React from 'react';
import InView from 'react-intersection-observer';

import { LazyImage } from 'main/components';

export const ShawnAmesSpotlight: React.FC = () => (
  <InView triggerOnce={false}>
    {({ ref, inView }) => (
      <div className="fpvrace--testimonial fpvrace__testimonial--primary">
        <LazyImage
          src={require('main/assets/images/fpvonerace/shawn-ames-testimonial.webp')}
          alt="Racer Spotlight"
          className="fpvpilot__spotlight__mobile--img"
        />
        <div ref={ref} className="fpvrace__spotlight--wrapper">
          <div className="fpvrace__spotlight__content--secondary">
            <motion.h2
              ref={ref}
              initial={{ opacity: 0, y: '20px' }}
              animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : '20px' }}
              transition={{ ease: 'circOut', duration: 0.3 }}
              className="fpvpilot__spotlight--title"
            >
              A perfect combo!
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: '40px' }}
              animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : '40px' }}
              transition={{ ease: 'circOut', duration: 0.3, delay: 0.3 }}
              className="fpvpilot__spotlight--description"
            >
              “Orqa goggles are the perfect combination of quality and
              innovation. They understand what we need and simply deliver.”
            </motion.p>
            <motion.hr
              initial={{ width: 0 }}
              animate={{
                width: inView ? '100%' : '0',
              }}
              transition={{ ease: 'easeOut', duration: 0.3, delay: 0.3 }}
              className="fpvpilot__spotlight--divider"
            />

            <div className="fpvpilot__testimonial--wrapper">
              <motion.div
                initial={{ opacity: 0, y: '40px' }}
                animate={{
                  opacity: inView ? 1 : 0,
                  y: inView ? 0 : '40px',
                }}
                transition={{ ease: 'circOut', duration: 0.3, delay: 0.6 }}
                className="fpvpilot__testimonial--content"
              >
                <LazyImage
                  src={require('main/assets/images/fpvonerace/shawn-ames.webp')}
                  alt="Pilot Shawn Ames"
                  className="fpvpilot__testimonial--image"
                />
                <div>
                  <h3 className="fpvpilot__testimonial--description">
                    ShamesFPV
                  </h3>
                  <p className="fpvpilot__testimonial--title">Shawn Ames</p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    )}
  </InView>
);
